import '@wangeditor/editor/dist/css/style.css' // 引入 css
import React, { useState, useEffect } from 'react';
import { CloseOutlined, PlusOutlined, } from '@ant-design/icons';
import { Button, Card, Form, Input, Space, Image, Upload, Divider, message, Breadcrumb, Timeline, 
    // List,
     Radio } from 'antd';
import { useSearchParams } from 'react-router-dom';
import { request } from '@/utils'
import './index.scss'


const M2d63 = () => {



    const [messageApi, contextHolder] = message.useMessage();
    const token = localStorage.getItem('token_key')

    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewImage, setPreviewImage] = useState('');
    const [fileList, setFileList] = useState([]);
    const [scjson, setScjson] = useState([]);
    const [ticks, setTicks] = useState([]);


    const [urlp] = useSearchParams()
    const [form] = Form.useForm();

    useEffect(() => {
        async function getau() {
            const res = await request.post('/pms_style1_c', { pno: urlp.get('q') })
            setTicks(res.ticks)
            false && setScjson("") 
            // res.json.scjson && setScjson(res.json.scjson.map((m, i) => {
            //     return {
            //         children: <>
            //             <List style={{ '--font-size': '1em' }} key={`JT${i}`}>
            //                 <div style={{
            //                     width: '100%',
            //                     height: '39px',
            //                     background: '#02af6f',
            //                     color: '#FFF',
            //                     lineHeight: '39px',
            //                     paddingLeft: '10px',

            //                 }}
            //                     key={`JBTs${i}`}
            //                 >

            //                     {m[0].mname}
            //                 </div>

            //                 {m[0].upload && m[0].upload.map((up, ii) => {
            //                     return <>
            //                         <List.Item key={`img${i}${ii}`} className='rzlsit'>
            //                             {up.type.substring(0, up.type.indexOf("/")) === "image" && <Image src={up.url} preview={false} />}
            //                             {up.type.substring(0, up.type.indexOf("/")) === "video" && <video muted width='100%' controls src={up.url} />}
            //                         </List.Item>


            //                     </>


            //                 })}





            //                 {m[0].list && m[0].list.map((k, index) => (
            //                     <List.Item extra={<span
            //                         color='success'
            //                         fill='outline'
            //                         style={{
            //                             // '--border-color': `${token.pjson1.mcv}`,
            //                             '--border-radius': '3px', '--font-size': '26px'
            //                         }}
            //                         key={`lisz${index}`}
            //                     >
            //                         {k.second}
            //                     </span>} key='JB015' ><span> {k.first}</span></List.Item>

            //                 ))}






            //             </List>





            //         </>
            //     }
            // }))

            form.setFieldValue('pno', urlp.get('q'))
        }
        getau()
    }, [urlp, form, ticks])
    //更新颜色






    const onFinish = async (values) => {
        console.log(JSON.stringify(values))
        const resc = await request.post('/pms_scrz_add', values)
        setTicks(resc.ticks)
        messageApi.open({
            type: resc.return_code,
            content: resc.return_msg,
        });

    }

    // const onFinish = (values) => {
    //     console.log(JSON.stringify(values))
    //     // const resc = await request.post('/pms_scrz_add', values)


    //     // setTicks(resc.ticks) 
    //     messageApi.open({
    //         type: "success",
    //         content:"sss",
    //     });

    // }



    const onRemove = async (e) => {
        await request.post('/p_upfile_d', e)
    }


    const handleChange = (filename, { fileList: newFileList }) => {

        if (newFileList[0] !== undefined && newFileList[0].status === 'done') {

            newFileList = newFileList.map((file) => {


                if (file.response) {
                    if (file.response.return_code === 'success') {
                        file.uid = file.response.fbody[0].uid;
                        file.name = file.response.fbody[0].name;
                        file.status = file.response.fbody[0].status;
                        file.url = file.response.fbody[0].url;
                    }
                    if (file.response.return_code === 'F') { file.status = "" }
                    //这里可以更新
                }
                delete file.response;
                delete file.originFileObj;
                delete file.lastModified;
                delete file.lastModifiedDate;
                delete file.percent;
                delete file.size;
                delete file.xhr;
                return file;
            });
        }
        setFileList(newFileList)

        form.setFieldValue(['scjson', filename, 'upload'], newFileList);

    }
    const uploadButton = (
        <button
            style={{
                border: 0,
                background: 'none',
            }}
            type="button"
        >
            <PlusOutlined />
            <div
                style={{
                    marginTop: 8,
                }}
            >
                Upload
            </div>
        </button>
    );



    const props = {
        action: 'http://api.ddspp.com:30123/v3/p_upfile',
        showUploadList: true,
        listType: 'picture-card',
        headers: { Authorization: `{"Bearer_ddspp":"${token}"}` },
    };




    return (<>{contextHolder}

        <Breadcrumb
            items={[
                {
                    title: '基础数据',
                },
                {
                    title: '生产日志',
                },

            ]}
        />
        <Form
            name='form'
            labelCol={{
                span: 6,
            }}
            wrapperCol={{
                span: 18,
            }}
            onFinish={onFinish}
            form={form}

            style={{
                maxWidth: 1200,
                marginTop: '10px'
            }}
            autoComplete="off"
            initialValues={{
                mjson: [{}],
            }}
        >
            <Form.Item
                hidden={true}
                name='pno'  >
                <Input />
            </Form.Item>
            <Form.Item
                // hidden={true}
                rules={[{ required: true, message: '请选择信息栏目' }]}
                name='dw'  >
                <Radio.Group buttonStyle="solid">
                    <Radio.Button value="ycm1">基地信息</Radio.Button>
                    <Radio.Button value="ycm2">种源信息</Radio.Button>
                    <Radio.Button value="ycm3">种植信息</Radio.Button>
                    <Radio.Button value="ycm4">农事记录</Radio.Button>
                    <Radio.Button value="ycm5">采收信息</Radio.Button>
                    <Radio.Button value="ycm6">加工信息</Radio.Button>
                    <Radio.Button value="ycm7">包装信息</Radio.Button>
                    <Radio.Button value="ycm8">仓储信息</Radio.Button>
                    <Radio.Button value="ycm9">质检信息</Radio.Button>

                </Radio.Group>
            </Form.Item>
            <Form.List name="scjson" >



                {(fields, { add, remove }) => (


                    <div
                        style={{
                            // display: 'flex',
                            // rowGap: 16,
                            // flexDirection: 'column',
                        }}
                    >

                        {/* <Form.Item label="主题颜色" > */}
                        <Space>


                            <Button type="dashed" onClick={() => add()} >
                                + 添加模块
                            </Button>






                        </Space>




                        {fields.map((field) => (
                            <Card
                                style={{
                                    width: '100%',
                                    // backgroundColor:"red"
                                }}
                                size="small"
                                title={`模块 ${field.name + 1}`}
                                key={field.key}
                                extra={
                                    <CloseOutlined
                                        onClick={() => {
                                            remove(field.name);
                                        }}
                                    />

                                }

                            >


                                <Form.Item label="模块名称" name={[field.name, 'mname']} style={{ alignContent: "flex-start" }}>
                                    <Input count={{ show: true, }} />
                                </Form.Item>



                                <Upload
                                    {...props}
                                    // fileList={fileList}
                                    fileList={form.getFieldValue(['scjson', field.name, 'upload'])}
                                    onChange={(info) => handleChange(field.name, info)}
                                    onRemove={(info) => onRemove(field.name, info)}


                                >
                                    {fileList.length >= 5 ? null : uploadButton}
                                </Upload>
                                {previewImage && (
                                    <Image
                                        wrapperStyle={{
                                            display: 'none',
                                        }}
                                        preview={{
                                            visible: previewOpen,
                                            onVisibleChange: (visible) => setPreviewOpen(visible),
                                            afterOpenChange: (visible) => !visible && setPreviewImage(''),
                                        }}
                                        src={previewImage}
                                    />
                                )}
                                <Divider />
                                <Form.Item hidden={true} name={[field.name, 'upload']} style={{ alignContent: "flex-start" }}>
                                    <Input count={{ show: true, }} />
                                </Form.Item>




                                {/* Nest Form.List */}
                                <Form.Item label="子项信息">
                                    <Form.List name={[field.name, 'list']}>
                                        {(subFields, subOpt) => (
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    rowGap: 16,
                                                }}
                                            >
                                                {subFields.map((subField) => (
                                                    <Space key={subField.key}>
                                                        <Form.Item noStyle name={[subField.name, 'first']}>
                                                            <Input placeholder="类目名称" />
                                                        </Form.Item>
                                                        <Form.Item noStyle name={[subField.name, 'second']}>
                                                            <Input placeholder="内容" />
                                                        </Form.Item>
                                                        <CloseOutlined
                                                            onClick={() => {
                                                                subOpt.remove(subField.name);
                                                            }}
                                                        />
                                                    </Space>
                                                ))}
                                                <Button type="dashed" onClick={() => subOpt.add()} >
                                                    + 添加子项目
                                                </Button>
                                            </div>
                                        )}
                                    </Form.List>
                                </Form.Item>
                            </Card>
                        ))}






                    </div>





                )}


            </Form.List>
            <Divider />

            <Form.Item > <Button type="primary"
                htmlType="submit"
                block
            >
                提   交
            </Button>
            </Form.Item>

        </Form>



        {false && <Timeline
            className='tlclass'
            items={

                scjson
            }
        />}


    </>

    );
};
export default M2d63